import axios from 'axios'
import router from '../../router'

export default {
    state : { 
        baseUrl:process.env.API_URL,
        persons:[],
        person:{},
        brands:[],
        vendors:[],
        imported_file:{},
        bulk_import_tasks:[],
        dashboard:{
            ARAMA:{},MESAJ:{},EPOSTA:{}
        }
    },
    getters : {
        persons:(state) =>{
            return state.persons
        },
        person:(state) =>{
            return state.person
        },
        brands:(state) =>{
            return state.brands
        },
        vendors:(state) =>{
            return state.vendors
        },
        imported_file:(state) =>{
            return state.imported_file
        },
        bulk_import_tasks:(state) =>{
            return state.bulk_import_tasks
        },
        dashboard:(state) =>{
            return state.dashboard
        }
     },
    mutations : { 
        persons(state, data){
            state.persons = data
        },
        person(state, data){
            state.person = data
        },
        brands(state, data){
            state.brands = data
        },
        vendors:(state,data) =>{
            state.vendors = data
        },
        imported_file:(state,data) =>{
            state.imported_file = data
        },
        bulk_import_tasks:(state,data) =>{
            state.bulk_import_tasks = data
        },
        dashboard:(state,data) =>{
            state.dashboard = data
        }
     },
    actions : { 
        getPersons({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getPersons`,form)
                .then(response => {
                    console.log("getPersons action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        commit('persons',response.data.content.persons)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("getPersons action error")
                    console.log(e)
                    reject()
                })
            })
        },
        getPerson({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getPerson`,form)
                .then(response => {
                    console.log("getPerson action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        commit('person',response.data.content.person)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("getPerson action error")
                    console.log(e)
                    reject()
                })
            })
        },
        getPersonByRecipient({state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getPersonByRecipient`,form)
                .then(response => {
                    console.log("getPersonByRecipient action response.data")
                    console.log(response.data)
                    resolve(response.data)
                })
                .catch(e => {
                    console.log("getPersonByRecipient action error")
                    console.log(e)
                    reject()
                })
            })
        },
        importFile({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/importFile`,form)
                .then(response => {
                    console.log("importFile action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        commit('imported_file',response.data.content.userDocumentDoc)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("importFile action error")
                    console.log(e)
                    reject()
                })
            })
        },
        getBulkImportTasks({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getBulkImportTasks`,form)
                .then(response => {
                    console.log("getBulkImportTasks action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        commit('bulk_import_tasks',response.data.content.result.bulk_import_tasks)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("getBulkImportTasks action error")
                    console.log(e)
                    reject()
                })
            })
        },
        getBrands({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getBrands`,form)
                .then(response => {
                    console.log("getBrands action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        commit('brands',response.data.content.result)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("getBrands action error")
                    console.log(e)
                    reject()
                })
            })
        },
        getVendors({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getVendors`,form)
                .then(response => {
                    console.log("getVendors action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        commit('vendors',response.data.content.result)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("getVendors action error")
                    console.log(e)
                    reject()
                })
            })
        },


        // Consult Our Experts

        getConsultOurExperts({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getConsultOurExperts`,form)
                .then(response => {
                    console.log("getVendors action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        commit('vendors',response.data.content.result)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("getVendors action error")
                    console.log(e)
                    reject()
                })
            })
        },


        createBulkImportTask({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/createBulkImportTask`,form)
                .then(response => {
                    console.log("createBulkImportTask action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('persons',response.data.content.persons)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("createBulkImportTask action error")
                    console.log(e)
                    reject()
                })
            })
        },
        confirmBulkImportTask({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/confirmBulkImportTask`,form)
                .then(response => {
                    console.log("confirmBulkImportTask action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('persons',response.data.content.persons)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("confirmBulkImportTask action error")
                    console.log(e)
                    reject()
                })
            })
        },
        exportBulkImportTaskDetails({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/exportBulkImportTaskDetails`,form)
                .then(response => {
                    console.log("exportBulkImportTaskDetails action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('persons',response.data.content.persons)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("exportBulkImportTaskDetails action error")
                    console.log(e)
                    reject()
                })
            })
        },
        getDashBoard({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getDashBoard`,form)
                .then(response => {
                    console.log("getDashBoard action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        commit('dashboard',response.data.content)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("getDashBoard action error")
                    console.log(e)
                    reject()
                })
            })
        },
        createPerson({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/createPerson`,form)
                .then(response => {
                    console.log("createPerson action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('person',response.data.content.person)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("createPerson action error")
                    console.log(e)
                    reject()
                })
            })
        },
        updatePerson({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/updatePerson`,form)
                .then(response => {
                    console.log("updatePerson action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('person',response.data.content.person)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("updatePerson action error")
                    console.log(e)
                    reject()
                })
            })
        },
        insertRecord({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/insertRecord`,form)
                .then(response => {
                    console.log("insertRecord action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('person',response.data.content.person)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("insertRecord action error")
                    console.log(e)
                    reject()
                })
            })
        },
        updateRecord({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/updateRecord`,form)
                .then(response => {
                    console.log("updateRecord action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('person',response.data.content.person)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("updateRecord action error")
                    console.log(e)
                    reject()
                })
            })
        },
        confirmMetaRecords({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/confirmMetaRecords`,form)
                .then(response => {
                    console.log("confirmMetaRecords action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('person',response.data.content.person)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("confirmMetaRecords action error")
                    console.log(e)
                    reject()
                })
            })
        },

        deleteMetaRecords({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/deleteMetaRecords`,form)
                .then(response => {
                    console.log("deleteMetaRecords action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('person',response.data.content.person)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("deleteMetaRecords action error")
                    console.log(e)
                    reject()
                })
            })
        },

        // Action tanımladık
        addRetailerAccess({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/addRetailerAccess`,form)
                .then(response => {
                    console.log("addRetailerAccess action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('person',response.data.content.person)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("addRetailerAccess action error")
                    console.log(e)
                    reject()
                })
            })
        },


        removeRetailerAccess({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/removeRetailerAccess`,form)
                .then(response => {
                    console.log("removeRetailerAccess action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //commit('person',response.data.content.person)
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log("removeRetailerAccess action error")
                    console.log(e)
                    reject()
                })
            })
        },



     }
}



// WEBPACK FOOTER //
// ./src/store/iyspanelGateway/consents.js